import React, { useState } from "react";
import { TextInputPage as PageType, UserProfile } from "../../types/quiz";
import { validateText } from "../../utils/quizLogic";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  userProfile: UserProfile;
  onAnswer: (value: string) => void;
}

const TextInputPage: React.FC<Props> = ({ page, userProfile, onAnswer }) => {
  const initialValue = page.data_field
    ? (userProfile[page.data_field] as string) || ""
    : "";
  const [value, setValue] = useState<string>(initialValue);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    // Validate
    const validation = validateText(value, page.validation);
    if (!validation.valid) {
      setError(validation.error || "Invalid input");
      return;
    }

    // Submit
    setError(null);
    onAnswer(value);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="page page--text-input">
      <div className="page__container">
        <h2 className="page__question">{page.question}</h2>

        <div className="text-input">
          <input
            type={page.inputType}
            className={`text-input__field ${error ? "text-input__field--error" : ""}`}
            placeholder={page.placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
          {error && <p className="text-input__error">{error}</p>}
        </div>

        <div className="page__actions">
            <button
              className="page__button page__button--block"
              onClick={handleSubmit}
              disabled={!value.trim()}
            >
              {page.buttonText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default TextInputPage;
